/**
 * @file HOC for redirecting to faces view if there is no selected
 * identity on discover mode.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter, Redirect } from 'react-router-dom';

const WithRequireIdentity = WrappedComponent =>
  class extends Component {
    static propTypes = {
      currentIdentityId: PropTypes.string,
      match: PropTypes.shape({
        url: PropTypes.string,
      }),
    };

    render() {
      const { currentIdentityId, match } = this.props;

      return !currentIdentityId ? (
        <Redirect
          to={`/discover/album-folder/${match.params.albumFolderId}/faces`}
        />
      ) : (
        <WrappedComponent {...this.props} />
      );
    }
  };

const mapStateToProps = ({ discoverAlbumFolder }) => ({
  currentIdentityId: discoverAlbumFolder.currentIdentityId,
});

export { WithRequireIdentity };

export default WrappedComponent => {
  return compose(
    withRouter,
    connect(mapStateToProps),
    WithRequireIdentity,
  )(WrappedComponent);
};
